import React from "react";
import "./SettlementCard.css";

const SettlementCard = ({
  summary,
  pendingSettlements,
}) => {
  const processing = pendingSettlements.filter(
    (item) =>
      item.settlementStatus === "Processing"
  );

  const completed = pendingSettlements.filter(
    (item) =>
      item.settlementStatus === "Completed"
  );

  const lastSettlement =
    completed.length > 0
      ? new Date(
          completed[0].updatedAt
        ).toLocaleDateString()
      : "No Settlement";

  const nextSettlement = new Date();

  nextSettlement.setDate(
    nextSettlement.getDate() + 3
  );

  return (
    <div className="settlement-card">

      <div className="settlement-header">

        <h2>Settlement Summary</h2>

        <span>🏦</span>

      </div>

      <div className="settlement-item">

        <span>Pending Amount</span>

        <strong>
          ₹
          {summary.pendingSettlement.toLocaleString()}
        </strong>

      </div>

      <div className="settlement-item">

        <span>Pending Orders</span>

        <strong>
          {pendingSettlements.length}
        </strong>

      </div>

      <div className="settlement-item">

        <span>Processing</span>

        <strong>
          {processing.length}
        </strong>

      </div>

      <div className="settlement-item">

        <span>Completed</span>

        <strong>
          {completed.length}
        </strong>

      </div>

      <div className="settlement-item">

        <span>Last Settlement</span>

        <strong>
          {lastSettlement}
        </strong>

      </div>

      <div className="settlement-item">

        <span>Next Settlement</span>

        <strong>
          {nextSettlement.toLocaleDateString()}
        </strong>

      </div>

      <div className="settlement-note">

        <p>
          Settlements are processed automatically
          after successful verification.
        </p>

      </div>

    </div>
  );
};

export default SettlementCard;